/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTracking } from '@facephi/sdk-web';
import { useRecoilValue } from 'recoil';
import { RequestMethods, useRequest, useLogger } from '../hooks';
import { useAuth } from '../providers';
import { endPoints } from '../states';
import { operationIdState } from '../states/atoms/operationId';
import { FacialMatchingDto } from '../states/model';
import { getBase64Image } from '../utils';
import { useVariables } from './useVariables';

type FacialMatchingParameters = FacialMatchingDto & {
  operation?: string;
  session?: string;
};

export function useMatchingTracking() {
  const { sessionId } = useTracking();
  const { demoVersion } = useAuth();
  const { apiDemoUrl } = useVariables();
  const { requestBasic: demoRequest } = useRequest(apiDemoUrl);
  const operationId = useRecoilValue(operationIdState);
  const { captureException } = useLogger();

  const matchingTracking = async ({
    operation,
    session,
    family,
    source,
    image,
    result,
  }: FacialMatchingParameters) => {
    try {
      const responseTracking: any = await demoRequest(
        endPoints.MatchingTracking,
        {
          method: RequestMethods.post,
          headers: {
            'x-demo-app-version': demoVersion,
            'x-inphinite-operationid': operation || operationId,
            'x-inphinite-sessionid': sessionId || session,
          },
          data: {
            family: family || 'ONBOARDING',
            result,
            source: source.toLowerCase(),
            image: getBase64Image(image),
          },
        }
      );
      return responseTracking;
    } catch (e: any) {
      captureException(e, {
        operation: 'TrackingFacialMatching',
        url: endPoints.MatchingTracking,
        operationId: operation || operationId,
      });
      throw new Error(e);
    }
  };

  return {
    matchingTracking,
  };
}
